export const sanitizeFilename = (name: string) => {
    const [base, ...extParts] = name.trim().split(".");
    const ext = extParts.length ? extParts.pop()!.toLowerCase() : "";
    const cleanBase = base
        .normalize("NFD")
        .replace(/[\u0300-\u036f\s.'’]+/g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "")
        .replace(/_+/g, "_")
        .replace(/^_+|_+$/g, "")
        .toLowerCase();
    return encodeURIComponent(ext ? `${cleanBase}.${ext}` : cleanBase);
};
